module.exports = __webpack_public_path__ + "fonts/NespressoLucas-SemiBdItalic.ttf?v=dc5526ceca3d6cc6db93897d8d1018ce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-SemiBdItalic.ttf
// module id = 678
// module chunks = 0